<template>
  <SelectWithSearch
    v-model="input"
    labelBusca="name"
    placeholder="Município"
    :disabled="disabled"
    :clearable="false"
    :label="label"
    :change="change"
    :options="cityCollection"
    :resizeSearchField="resizeSearchField"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
    <template slot="no-options"> Nenhum minicípio encontrado </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectUf',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    error: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: String,
      default: 'Município',
    },
    uf: {
      type: String,
      default: null,
    },
    cityCode: {
      type: String,
      default: null,
    },
    resizeSearchField: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  computed: {
    ...mapState('core', ['cityCollection']),
  },
  methods: {
    ...mapActions('core', ['setCityCollection', 'setCityByCode']),

    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
    uf(current, previous) {
      if (previous !== current && current !== this.input?.acronym) {
        this.change(null);
      }

      this.setCityCollection(current);
    },
    async cityCode(current, previous) {
      if (current && previous !== current) {
        const city = await this.setCityByCode(current);

        this.change(city);
      }
    },
  },
};
</script>
